export default __webpack_public_path__ + "static/media/Vv.7a78f71f.wav";